import TTrialApplicationInviteUser from './index.vue';

TTrialApplicationInviteUser.install = app => {
  app.component(TTrialApplicationInviteUser.name, TTrialApplicationInviteUser);
};

export default TTrialApplicationInviteUser;
